var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-simple",attrs:{"href":"#","type":"button","id":"forgotPassword"},on:{"click":function($event){return _vm.passowrdReset()}}},[_vm._v(" "+_vm._s(_vm.$t('common.labels.forgotYourPassword'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }